import { create } from 'zustand';
import type { MenuOptions } from './types';

export type CommandMenuStateMenu =
  | 'commands'
  | 'embed'
  | 'mentionDoc'
  | 'mentionTableRow'
  | 'askAi';

export type CommandMenuState = {
  currentMenu: CommandMenuStateMenu;
  menuOptions: MenuOptions | null;
  changeMenu: (
    currentMenu: CommandMenuStateMenu,
    menuOptions: MenuOptions | null,
  ) => void;
  reset: () => void;
};

export const commandMenuState = create<CommandMenuState>((set) => ({
  currentMenu: 'commands',
  menuOptions: null,
  changeMenu: (currentMenu, menuOptions) => set({ currentMenu, menuOptions }),
  reset: () => set({ currentMenu: 'commands', menuOptions: null }),
}));
